import { Injectable } from '@angular/core';
import {ApiService} from "../../../services/api/api.service";
import {Observable} from "rxjs";
import {PaymentListModelsDto} from "../models/terminal.models";
import {UserInfoService} from "../../../services/user-info.service";
import {SortTableService} from "../../../services/sort-table.service";
import {FilterSearchResultDto} from "../../../models/filter.model";

@Injectable({
  providedIn: 'root'
})
export class TerminalDataServiceService {

  agentId: string | undefined
  userId: number | undefined

  sort: string | undefined

  constructor(
    private apiService: ApiService,
    private userInfoService: UserInfoService,
    private sortTableService: SortTableService
  ) {

    this.userInfoService.userId$.subscribe({
      next: (res) => {
        this.userId = res
      }
    })

    this.userInfoService.agentId$.subscribe({
      next: (res) => {
        this.agentId = res
      }
    })

    this.sortTableService.sortColum$.subscribe({
      next: (res) => {
        this.sort = res
      }
    })
  }

  loadTerminals(page: number, search: string | undefined = '', data?: any): Observable<PaymentListModelsDto> {
    const url = `/agents/${this.agentId}/terminals/filter?page_number=${page}&per_page=20&${this.sort}&search=${search}`
    return this.apiService.httpPost<PaymentListModelsDto>(url, data)
  }

  loadTerminalFilter() {
    const url = `/agents/${this.agentId}/terminals/filter`
    return this.apiService.httpGet<any>(url)
  }

  loadSearchList(data: any): Observable<FilterSearchResultDto> {
    const url = `/agents/${this.agentId}/terminals/filter/list?page_number=0&per_page=10`
    return this.apiService.httpPost<FilterSearchResultDto>(url, data)
  }
}
